import { makeStyles } from '@material-ui/core';

const height = 360;

const useStyles = makeStyles(
  {
    root: {
      boxSizing: 'border-box',
      maxWidth: '100%',

      '&:hover': {
        '& $sliderButton': {
          opacity: 100,
        },
      },
    },
    carousel: {
      overflow: 'hidden',
      position: 'relative',
      height: `${height}px`, // TODO set elsewhere
      backgroundColor: (props) => (props?.showBackground ? '#202020' : 'transparent'),
    },
    slide: {
      width: '100%',
      position: 'absolute',
      userSelect: 'none',
    },
    slideActive: {
      zIndex: '10',
    },
    slideActiveRange: {
      zIndex: '10',
      transition: 'transform 0.3s ease-in-out',
    },
    slideContent: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'none',
      // height: `${height}px`, // TODO set elsewhere
    },
    caption: {
      // width: '100%',
      position: 'absolute',
      padding: '12px',
      top: '0',
      left: '0',
      zIndex: '5',
      userSelect: 'none',
      pointerEvents: 'none',
    },
    sliderImage: {
      width: '100%',

      // NOTE: some images look better with cover and others with contain
      // objectFit: 'cover',
      objectFit: (props) => props?.fitStyle ?? 'contain',
    },
    paginationContainer: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      zIndex: '20',
      bottom: '16px',
    },
    pagination: {
      display: 'inline-flex',
      gap: '6px',
    },
    paginationDot: {
      width: '12px',
      height: '12px',
      borderRadius: '10px',
      backgroundColor: 'white',
      opacity: '50%',
      cursor: 'pointer',
      border: '1px solid #CCCCCC',

      '&:hover': {
        opacity: '75%',
      },
    },
    paginationDotActive: {
      opacity: '100%',
      border: '1px solid #BBBBBB',
    },
    sliderButton: {
      zIndex: '30',
      position: 'absolute',

      // To fade in when hovered
      transition: 'opacity 0.2s',
      opacity: (props) => (props?.hoverControls ? 0 : 100),

      // To show at bottom
      bottom: '16px',

      // To show in center
      // top: '50%',
      // transform: 'translate(0, -50%)',
    },
  },
  { name: 'Carousel' },
);

export default useStyles;
